<div class="container content-block">
  <div class="row">
    <div class="col-sm-3"><h6>Data Load Status</h6></div>
    <div class="col-sm-3">
      <div class="dx-field">
        <div class="dx-field-label">Begin Date</div>
        <div class="dx-field-value">
          <dx-date-box [value]="beginDate"
                       type="date">
          </dx-date-box>
        </div>
      </div>
    </div>
    <div class="col-sm-3">
      <div class="dx-field">
        <div class="dx-field-label">End Date</div>
        <div class="dx-field-value">
          <dx-date-box [value]="endDate"
                       type="date">
          </dx-date-box>
        </div>
      </div>
    </div>
    <div class="col-sm-3">
      <dx-button stylingMode="contained"
                 type="normal"
                 text="Generate"
                 width="120"
                 (onClick)="generateClicked($event)"></dx-button>
    </div>
  </div>
</div>
<div>
  <app-tree-map (onDrill)="drill()"></app-tree-map>
  <app-grid name="Data Load Status Detail"
            [height]="500"></app-grid>
</div>
